export const COIN_GECKO_URL = "https://api.coingecko.com/api/v3/coins/";
export const NEWS_API = 'https://newsapi.org/v2/everything?q=tesla&from=2022-11-03&sortBy=publishedAt&apiKey=dd982a8bb9974e3bb39e4d3a46e7a238'

export const APP_URL = 'https://6359fcdf812f6a2f258756f5--symphonious-basbousa-640fc5.netlify.app/'

export const APP_NAME = "CryptoTracker.";
export const APP_DESCRIPTION =
  "CryptoTracker is the tracker you always needed. Compare different crypto currencies, look at their graphs - prices, total volumes, market cap, etc. Search from the top 100 Crypto currencies in real time.";
export const APP_KEYWORDS =
  "CryptoTracker., crypto, tracker, crypto dashboard, dashboard";
export const APP_AUTHOR = "Srimanthula Yerni Teja";
